import{AsyncAction as r}from"./AsyncAction.js";import{AsyncScheduler as o}from"./AsyncScheduler.js";var c=new o(r),e=c;export{e as async,c as asyncScheduler};
